class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    const header = document.querySelector('header');
    this.triggerType = header && header.dataset.triggerType ? header.dataset.triggerType : 'click';

    if (this.triggerType === 'hover') {
      this.mainDetailsToggle.addEventListener('mouseenter', this.openOnHover.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.closeOnHover.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => e.preventDefault());
    } else {
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  openOnHover() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  closeOnHover() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.cancel());
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Add clickable parent link functionality for hover trigger
    if (this.triggerType === 'hover') {
      this.addClickableParentLink();
    }
  }

  addClickableParentLink() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const linkUrl = summary.dataset.linkUrl;
    
    if (linkUrl) {
      // Listen for clicks on the summary element
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        // Navigate to the parent link URL
        window.location.href = linkUrl;
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);